import { ArrowDropDown, type SvgIconComponent } from "@mui/icons-material"
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  ToggleButton,
  type ToggleButtonProps,
  styled,
} from "@mui/material"
import { type MouseEvent, useState } from "react"

export interface ToolbarDropdownProps {
  Icon: SvgIconComponent
  size: ToggleButtonProps["size"]
  items: ToolbarDropdownMenuItem[]
  disabled?: boolean
}

export const ToolbarDropdown = ({
  Icon,
  size,
  items,
  disabled = false,
}: ToolbarDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }
  const handleClose = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    setAnchorEl(null)
  }

  return (
    <>
      <ToggleButton onClick={handleClick} size={size} value="" disabled={disabled}>
        <Icon />
        <ArrowDropDown />
      </ToggleButton>

      <Menu
        onClick={handleClose}
        onClose={handleClose}
        anchorEl={anchorEl}
        open={!!anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {items.map(({ Icon: ItemIcon, label, onClick }, index) => (
          <MenuItem key={index} onClick={onClick}>
            <ListItemIcon>
              <ItemIcon />
            </ListItemIcon>
            {!!label && <Label color="grey">{label}</Label>}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export interface ToolbarDropdownMenuItem {
  Icon: SvgIconComponent
  label?: string
  onClick: (event: MouseEvent<HTMLElement>) => void
}

const Label = styled(ListItemText)(({ theme }) => ({
  color: theme.palette.grey.dark,
}))
